// extracted by mini-css-extract-plugin
module.exports = {"patientId":"PatientList_patientId__3fbUb","summaryList":"PatientList_summaryList__2c8Qx"};